import config from '../../../config/App_data';
import GetData from '../../../RestAPI/getDataService';

const fetchReadingList = async data => {
  return await GetData.callAPI(`${config.backend_api}/exams/cfa/question-bank/reading`, data);
};

const pdfDownloadViaEmail = async data => {
  return await GetData.callAPI(`${config.backend_api}/exams/cfa/question-bank/pdf-download`, data);
};
module.exports = {
  fetchReadingList,
  pdfDownloadViaEmail,
};



// WEBPACK FOOTER //
// ./src/views/CFA1-2025/QuestionBank/QuestionReadingList/ApiService.js